export default "<section class=\"loader-container\" [ngClass]=\"{'d-none': !isLoading}\">\n    <div class=\"lds-dual-ring\"></div>\n</section>";